import { combineReducers, Reducer, ReducersMapObject } from 'redux';
import favoritesReducer from './peopleHub/favoritesReducer';
import suggestedPersonasReducer from './peopleHub/suggestedPersonasReducer';
import deletedPersonasReducer from './peopleHub/deletedPersonasReducer';
import currentNavigationPersonaReducer from './peopleHub/currentNavigationPersonaReducer';
import emailToPDLsReducer from './peopleHub/emailToPDLsReducer';
import type { HubState } from '../..';

const reducer: Reducer<HubState> = combineReducers<HubState>({
    favoritePersonsState: favoritesReducer,
    suggestedPersonasState: suggestedPersonasReducer,
    deletedPersonasState: deletedPersonasReducer,
    currentNavigationPersonaState: currentNavigationPersonaReducer,
    emailToPDLsMapState: emailToPDLsReducer,
} as ReducersMapObject<HubState>);

export default reducer;
